"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMarkdownDiffNew = exports.formatBrilligRows = exports.formatCircuitRows = exports.formatMarkdownDiff = exports.formatShellDiffBrillig = exports.formatShellBrilligRows = exports.formatShellDiff = exports.formatShellCircuitRows = exports.formatShellCell = void 0;
const colors_1 = __importDefault(require("colors"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const utils_1 = require("./utils");
const formatShellCell = (cell, length = 10) => {
    const format = colors_1.default[cell.delta > 0 ? "red" : cell.delta < 0 ? "green" : "reset"];
    return [
        cell.current.toLocaleString().padStart(length) +
            " " +
            format((0, utils_1.parenthesized)((0, utils_1.plusSign)(cell.delta) + cell.delta.toLocaleString()).padEnd(length)),
        colors_1.default.bold(format(((0, utils_1.plusSign)(cell.percentage) +
            (cell.percentage === Infinity ? "∞" : cell.percentage.toFixed(2)) +
            "%").padStart(9))),
    ];
};
exports.formatShellCell = formatShellCell;
const selectSummaryDiffs = (diffs, minCircuitChangePercentage) => diffs.filter((method) => Math.abs(method.circuit_size.percentage) >= minCircuitChangePercentage &&
    (method.opcodes.delta !== 0 || method.circuit_size.delta !== 0));
const selectSummaryDiffsBrillig = (diffs, minCircuitChangePercentage) => diffs.filter((method) => Math.abs(method.opcodes.percentage) >= minCircuitChangePercentage &&
    method.opcodes.delta !== 0);
const formatShellCircuitRows = (diffs, summaryQuantile = 0.8) => {
    var _a, _b;
    const maxProgramLength = Math.max(8, ...diffs.map(({ name }) => name.length));
    const sortedPrograms = (0, sortBy_1.default)(diffs, (method) => Math.abs(method.circuit_size.percentage));
    const circuitChangeQuantile = Math.abs((_b = (_a = sortedPrograms[Math.floor((sortedPrograms.length - 1) * summaryQuantile)]) === null || _a === void 0 ? void 0 : _a.circuit_size.percentage) !== null && _b !== void 0 ? _b : 0);
    const summaryRows = selectSummaryDiffs(diffs, circuitChangeQuantile).map((diff) => [
        "",
        colors_1.default.bold(colors_1.default.grey(diff.name.padEnd(maxProgramLength))),
        ...(0, exports.formatShellCell)(diff.opcodes),
        ...(0, exports.formatShellCell)(diff.circuit_size),
        "",
    ]
        .join(" | ")
        .trim());
    const fullReportRows = diffs.map((diff) => [
        "",
        colors_1.default.bold(colors_1.default.grey(diff.name.padEnd(maxProgramLength))),
        ...(0, exports.formatShellCell)(diff.opcodes),
        ...(0, exports.formatShellCell)(diff.circuit_size),
        "",
    ]
        .join(" | ")
        .trim());
    return [summaryRows, fullReportRows];
};
exports.formatShellCircuitRows = formatShellCircuitRows;
const formatShellDiff = (diffs, summaryRows, fullReportRows, summaryQuantile = 0.8) => {
    const maxProgramLength = Math.max(8, ...diffs.map(({ name }) => name.length));
    const SHELL_SUMMARY_COLS = [
        { txt: "", length: 0 },
        { txt: "Program", length: maxProgramLength },
        { txt: "ACIR opcodes (+/-)", length: 33 },
        { txt: "Circuit size (+/-)", length: 33 },
        { txt: "", length: 0 },
    ];
    const SHELL_DIFF_COLS = [
        { txt: "", length: 0 },
        { txt: "Program", length: maxProgramLength },
        { txt: "ACIR opcodes (+/-)", length: 33 },
        { txt: "Circuit size (+/-)", length: 33 },
        { txt: "", length: 0 },
    ];
    const summaryHeader = SHELL_SUMMARY_COLS.map((entry) => colors_1.default.bold((0, utils_1.center)(entry.txt, entry.length || 0)))
        .join(" | ")
        .trim();
    const summarySeparator = SHELL_SUMMARY_COLS.map(({ length }) => length > 0 ? "-".repeat(length + 2) : "")
        .join("|")
        .trim();
    const diffHeader = SHELL_DIFF_COLS.map((entry) => colors_1.default.bold((0, utils_1.center)(entry.txt, entry.length || 0)))
        .join(" | ")
        .trim();
    const diffSeparator = SHELL_DIFF_COLS.map(({ length }) => length > 0 ? "-".repeat(length + 2) : "")
        .join("|")
        .trim();
    return (colors_1.default.underline(colors_1.default.bold(colors_1.default.yellow(`🧾 Summary (${Math.round((1 - summaryQuantile) * 100)}% most significant diffs)\n\n`))) +
        ["", summaryHeader, ...summaryRows, ""].join(`\n${summarySeparator}\n`).trim() +
        colors_1.default.underline(colors_1.default.bold(colors_1.default.yellow("\n\nFull diff report 👇\n\n"))) +
        ["", diffHeader, ...fullReportRows, ""].join(`\n${diffSeparator}\n`).trim());
};
exports.formatShellDiff = formatShellDiff;
const formatShellBrilligRows = (diffs, summaryQuantile = 0.8) => {
    var _a, _b;
    const maxProgramLength = Math.max(8, ...diffs.map(({ name }) => name.length));
    const sortedPrograms = (0, sortBy_1.default)(diffs, (method) => Math.abs(method.opcodes.percentage));
    const circuitChangeQuantile = Math.abs((_b = (_a = sortedPrograms[Math.floor((sortedPrograms.length - 1) * summaryQuantile)]) === null || _a === void 0 ? void 0 : _a.opcodes.percentage) !== null && _b !== void 0 ? _b : 0);
    const summaryRows = selectSummaryDiffsBrillig(diffs, circuitChangeQuantile).map((diff) => [
        "",
        colors_1.default.bold(colors_1.default.grey(diff.name.padEnd(maxProgramLength))),
        ...(0, exports.formatShellCell)(diff.opcodes),
        "",
    ]
        .join(" | ")
        .trim());
    const fullReportRows = diffs.map((diff) => [
        "",
        colors_1.default.bold(colors_1.default.grey(diff.name.padEnd(maxProgramLength))),
        ...(0, exports.formatShellCell)(diff.opcodes),
        "",
    ]
        .join(" | ")
        .trim());
    return [summaryRows, fullReportRows];
};
exports.formatShellBrilligRows = formatShellBrilligRows;
const formatShellDiffBrillig = (diffs, summaryRows, fullReportRows, summaryQuantile = 0.8) => {
    const maxProgramLength = Math.max(8, ...diffs.map(({ name }) => name.length));
    const SHELL_SUMMARY_COLS = [
        { txt: "", length: 0 },
        { txt: "Program", length: maxProgramLength },
        { txt: "ACIR opcodes (+/-)", length: 33 },
        { txt: "", length: 0 },
    ];
    const SHELL_DIFF_COLS = [
        { txt: "", length: 0 },
        { txt: "Program", length: maxProgramLength },
        { txt: "ACIR opcodes (+/-)", length: 33 },
        { txt: "", length: 0 },
    ];
    const summaryHeader = SHELL_SUMMARY_COLS.map((entry) => colors_1.default.bold((0, utils_1.center)(entry.txt, entry.length || 0)))
        .join(" | ")
        .trim();
    const summarySeparator = SHELL_SUMMARY_COLS.map(({ length }) => length > 0 ? "-".repeat(length + 2) : "")
        .join("|")
        .trim();
    const diffHeader = SHELL_DIFF_COLS.map((entry) => colors_1.default.bold((0, utils_1.center)(entry.txt, entry.length || 0)))
        .join(" | ")
        .trim();
    const diffSeparator = SHELL_DIFF_COLS.map(({ length }) => length > 0 ? "-".repeat(length + 2) : "")
        .join("|")
        .trim();
    return (colors_1.default.underline(colors_1.default.bold(colors_1.default.yellow(`🧾 Summary (${Math.round((1 - summaryQuantile) * 100)}% most significant diffs)\n\n`))) +
        ["", summaryHeader, ...summaryRows, ""].join(`\n${summarySeparator}\n`).trim() +
        colors_1.default.underline(colors_1.default.bold(colors_1.default.yellow("\n\nFull diff report 👇\n\n"))) +
        ["", diffHeader, ...fullReportRows, ""].join(`\n${diffSeparator}\n`).trim());
};
exports.formatShellDiffBrillig = formatShellDiffBrillig;
const formatMarkdownSummaryCell = (rows) => [
    rows
        .map((row) => (0, utils_1.plusSign)(row.delta) +
        row.delta.toLocaleString() +
        " " +
        (row.delta > 0 ? "❌" : row.delta < 0 ? "✅" : "➖"))
        .join("<br />"),
    rows
        .map((row) => "**" +
        (0, utils_1.plusSign)(row.percentage) +
        (row.percentage === Infinity ? "∞" : row.percentage.toFixed(2)) +
        "%**")
        .join("<br />"),
];
const formatMarkdownFullCell = (rows) => [
    rows
        .map((row) => row.current.toLocaleString() +
        "&nbsp;(" +
        (0, utils_1.plusSign)(row.delta) +
        row.delta.toLocaleString() +
        ")")
        .join("<br />"),
    rows
        .map((row) => "**" +
        (0, utils_1.plusSign)(row.percentage) +
        (row.percentage === Infinity ? "∞" : row.percentage.toFixed(2)) +
        "%**")
        .join("<br />"),
];
const MARKDOWN_SUMMARY_COLS_CIRCUIT = [
    { txt: "" },
    { txt: "Program", align: utils_1.TextAlign.LEFT },
    { txt: "ACIR opcodes (+/-)", align: utils_1.TextAlign.RIGHT },
    { txt: "%", align: utils_1.TextAlign.RIGHT },
    { txt: "Circuit size (+/-)", align: utils_1.TextAlign.RIGHT },
    { txt: "%", align: utils_1.TextAlign.RIGHT },
    { txt: "" },
];
const MARKDOWN_DIFF_COLS_CIRCUIT = [
    { txt: "" },
    { txt: "Program", align: utils_1.TextAlign.LEFT },
    { txt: "ACIR opcodes (+/-)", align: utils_1.TextAlign.RIGHT },
    { txt: "%", align: utils_1.TextAlign.RIGHT },
    { txt: "Circuit size (+/-)", align: utils_1.TextAlign.RIGHT },
    { txt: "%", align: utils_1.TextAlign.RIGHT },
    { txt: "" },
];
const MARKDOWN_SUMMARY_COLS_BRILLIG = [
    { txt: "" },
    { txt: "Program", align: utils_1.TextAlign.LEFT },
    { txt: "Brillig opcodes (+/-)", align: utils_1.TextAlign.RIGHT },
    { txt: "%", align: utils_1.TextAlign.RIGHT },
    { txt: "" },
];
const MARKDOWN_DIFF_COLS_BRILLIG = [
    { txt: "" },
    { txt: "Program", align: utils_1.TextAlign.LEFT },
    { txt: "Brillig opcodes (+/-)", align: utils_1.TextAlign.RIGHT },
    { txt: "%", align: utils_1.TextAlign.RIGHT },
    { txt: "" },
];
const formatMarkdownDiff = (header, diffs, repository, commitHash, refCommitHash, summaryQuantile = 0.8) => {
    var _a, _b;
    const diffReport = [header, "", (0, utils_1.generateCommitInfo)(repository, commitHash, refCommitHash)];
    if (diffs.length === 0)
        return diffReport.concat(["", "### There are no changes in circuit sizes"]).join("\n").trim();
    const summaryHeader = MARKDOWN_SUMMARY_COLS_CIRCUIT.map((entry) => entry.txt)
        .join(" | ")
        .trim();
    const summaryHeaderSeparator = MARKDOWN_SUMMARY_COLS_CIRCUIT.map((entry) => entry.txt ? (0, utils_1.alignPattern)(entry.align) : "")
        .join("|")
        .trim();
    const diffHeader = MARKDOWN_DIFF_COLS_CIRCUIT.map((entry) => entry.txt)
        .join(" | ")
        .trim();
    const diffHeaderSeparator = MARKDOWN_DIFF_COLS_CIRCUIT.map((entry) => entry.txt ? (0, utils_1.alignPattern)(entry.align) : "")
        .join("|")
        .trim();
    const sortedMethods = (0, sortBy_1.default)(diffs, (program) => Math.abs(program.circuit_size.percentage));
    const circuitChangeQuantile = Math.abs((_b = (_a = sortedMethods[Math.floor((sortedMethods.length - 1) * summaryQuantile)]) === null || _a === void 0 ? void 0 : _a.circuit_size.percentage) !== null && _b !== void 0 ? _b : 0);
    const summaryRows = selectSummaryDiffs(diffs, circuitChangeQuantile).flatMap((diff) => [
        "",
        `**${diff.name}**`,
        ...formatMarkdownSummaryCell([diff.opcodes]),
        ...formatMarkdownSummaryCell([diff.circuit_size]),
        "",
    ]
        .join(" | ")
        .trim());
    const fullReportRows = diffs.flatMap((diff) => [
        "",
        `**${diff.name}**`,
        ...formatMarkdownFullCell([diff.opcodes]),
        ...formatMarkdownFullCell([diff.circuit_size]),
        "",
    ]
        .join(" | ")
        .trim());
    return diffReport
        .concat([
        "",
        `### 🧾 Summary (${Math.round((1 - summaryQuantile) * 100)}% most significant diffs)`,
        "",
        summaryHeader,
        summaryHeaderSeparator,
        ...summaryRows,
        "---",
        "",
        "<details>",
        "<summary><strong>Full diff report</strong> 👇</summary>",
        "<br />",
        "",
        diffHeader,
        diffHeaderSeparator,
        ...fullReportRows,
        "</details>",
        "",
    ])
        .join("\n")
        .trim();
};
exports.formatMarkdownDiff = formatMarkdownDiff;
const formatCircuitRows = (diffs, summaryQuantile = 0.8) => {
    var _a, _b;
    const sortedMethods = (0, sortBy_1.default)(diffs, (program) => Math.abs(program.circuit_size.percentage));
    const circuitChangeQuantile = Math.abs((_b = (_a = sortedMethods[Math.floor((sortedMethods.length - 1) * summaryQuantile)]) === null || _a === void 0 ? void 0 : _a.circuit_size.percentage) !== null && _b !== void 0 ? _b : 0);
    const summaryRows = selectSummaryDiffs(diffs, circuitChangeQuantile).flatMap((diff) => [
        "",
        `**${diff.name}**`,
        ...formatMarkdownSummaryCell([diff.opcodes]),
        ...formatMarkdownSummaryCell([diff.circuit_size]),
        "",
    ]
        .join(" | ")
        .trim());
    const fullReportRows = diffs.flatMap((diff) => [
        "",
        `**${diff.name}**`,
        ...formatMarkdownFullCell([diff.opcodes]),
        ...formatMarkdownFullCell([diff.circuit_size]),
        "",
    ]
        .join(" | ")
        .trim());
    return [summaryRows, fullReportRows];
};
exports.formatCircuitRows = formatCircuitRows;
const formatBrilligRows = (diffs, summaryQuantile = 0.8) => {
    var _a, _b;
    const sortedMethods = (0, sortBy_1.default)(diffs, (program) => Math.abs(program.opcodes.percentage));
    const circuitChangeQuantile = Math.abs((_b = (_a = sortedMethods[Math.floor((sortedMethods.length - 1) * summaryQuantile)]) === null || _a === void 0 ? void 0 : _a.opcodes.percentage) !== null && _b !== void 0 ? _b : 0);
    const summaryRows = selectSummaryDiffsBrillig(diffs, circuitChangeQuantile).flatMap((diff) => ["", `**${diff.name}**`, ...formatMarkdownSummaryCell([diff.opcodes]), ""].join(" | ").trim());
    const fullReportRows = diffs.flatMap((diff) => ["", `**${diff.name}**`, ...formatMarkdownFullCell([diff.opcodes]), ""].join(" | ").trim());
    return [summaryRows, fullReportRows];
};
exports.formatBrilligRows = formatBrilligRows;
const formatMarkdownDiffNew = (header, repository, commitHash, summaryRows, fullReportRows, 
// Flag to distinguish the markdown columns that should be used
circuitReport, refCommitHash, summaryQuantile = 0.8) => {
    const diffReport = [header, "", (0, utils_1.generateCommitInfo)(repository, commitHash, refCommitHash)];
    if (fullReportRows.length === 0)
        return diffReport.concat(["", "### There are no changes in circuit sizes"]).join("\n").trim();
    let MARKDOWN_SUMMARY_COLS;
    let MARKDOWN_DIFF_COLS;
    if (circuitReport) {
        MARKDOWN_SUMMARY_COLS = MARKDOWN_SUMMARY_COLS_CIRCUIT;
        MARKDOWN_DIFF_COLS = MARKDOWN_DIFF_COLS_CIRCUIT;
    }
    else {
        MARKDOWN_SUMMARY_COLS = MARKDOWN_SUMMARY_COLS_BRILLIG;
        MARKDOWN_DIFF_COLS = MARKDOWN_DIFF_COLS_BRILLIG;
    }
    const summaryHeader = MARKDOWN_SUMMARY_COLS.map((entry) => entry.txt)
        .join(" | ")
        .trim();
    const summaryHeaderSeparator = MARKDOWN_SUMMARY_COLS.map((entry) => entry.txt ? (0, utils_1.alignPattern)(entry.align) : "")
        .join("|")
        .trim();
    const diffHeader = MARKDOWN_DIFF_COLS.map((entry) => entry.txt)
        .join(" | ")
        .trim();
    const diffHeaderSeparator = MARKDOWN_DIFF_COLS.map((entry) => entry.txt ? (0, utils_1.alignPattern)(entry.align) : "")
        .join("|")
        .trim();
    return diffReport
        .concat([
        "",
        `### 🧾 Summary (${Math.round((1 - summaryQuantile) * 100)}% most significant diffs)`,
        "",
        summaryHeader,
        summaryHeaderSeparator,
        ...summaryRows,
        "---",
        "",
        "<details>",
        "<summary><strong>Full diff report</strong> 👇</summary>",
        "<br />",
        "",
        diffHeader,
        diffHeaderSeparator,
        ...fullReportRows,
        "</details>",
        "",
    ])
        .join("\n")
        .trim();
};
exports.formatMarkdownDiffNew = formatMarkdownDiffNew;
